module.exports = __webpack_public_path__ + "assets/ceccd27f280b5766effe063df707e1ce.png";